export {};

if (import.meta.env.DEV) {
  console.warn("Console error override active");
}

const orig = console.error;
console.error = (...args) => {
  if (
    typeof args[0] === "string" &&
    args[0].includes(
      "The specified MIME type you supplied for MediaRecorder doesn't support this browser"
    )
  ) {
    return;
  }
  orig.apply(console, args);
};
